export default "__VITE_ASSET__BV6buvcv__"